import * as Curry from "bs-platform/lib/es6/curry.js";
import * as Job_atd$SolvuuApi0 from "./job_atd.bs.js";
import * as Service$SolvuuApi0 from "./service.bs.js";
import * as Job_create_request_atd$SolvuuApi0 from "./job_create_request_atd.bs.js";
import * as Job_get_all_response_atd$SolvuuApi0 from "./job_get_all_response_atd.bs.js";
import * as Job_get_by_id_request_atd$SolvuuApi0 from "./job_get_by_id_request_atd.bs.js";
import * as Job_get_events_request_atd$SolvuuApi0 from "./job_get_events_request_atd.bs.js";
var Spec = {};
var Solvuu = {
  Spec: Spec
};

function id(t) {
  return t.id;
}

function spec(t) {
  return t.spec;
}

function status(t) {
  return t.status;
}

function backend(t) {
  return t.backend;
}

function output(t) {
  return t.output;
}

function is_complete(param) {
  if (param !== -113393609) {
    return param < 785140586;
  } else {
    return false;
  }
}

var entity = "jobs";
var service = Service$SolvuuApi0.Get_by_id.service(entity);

var path = Curry._1(Service$SolvuuApi0.Get_by_id.$$Request.path, entity);

var body = Service$SolvuuApi0.Get_by_id.$$Request.body;

var info = Curry._1(Service$SolvuuApi0.Get_by_id.$$Request.info, entity);

var $$Request = {
  Json: Job_get_by_id_request_atd$SolvuuApi0.Json,
  json_of_info: Job_get_by_id_request_atd$SolvuuApi0.json_of_info,
  info_of_json: Job_get_by_id_request_atd$SolvuuApi0.info_of_json,
  path: path,
  body: body,
  info: info
};
var Get_by_id = {
  service: service,
  entity: entity,
  $$Request: $$Request,
  $$Response:
  /* alias */
  0
};
var service$1 = Service$SolvuuApi0.Get_all.service(entity);

function path$1(param) {
  return Curry._1(Service$SolvuuApi0.Get_all.$$Request.path, entity);
}

function body$1(param) {
  return Service$SolvuuApi0.Get_all.$$Request.body;
}

function info$1(param, param$1) {
  return Service$SolvuuApi0.Get_all.$$Request.info;
}

var Get_all_Request = {
  path: path$1,
  body: body$1,
  info: info$1
};
var Get_all_Response = {
  ok_of_json: Job_get_all_response_atd$SolvuuApi0.ok_of_json,
  json_of_ok: Job_get_all_response_atd$SolvuuApi0.json_of_ok,
  bad_request_of_json: Job_get_all_response_atd$SolvuuApi0.bad_request_of_json,
  json_of_bad_request: Job_get_all_response_atd$SolvuuApi0.json_of_bad_request,
  not_found_of_json: Job_get_all_response_atd$SolvuuApi0.not_found_of_json,
  json_of_not_found: Job_get_all_response_atd$SolvuuApi0.json_of_not_found
};
var Get_all = {
  entity: entity,
  service: service$1,
  $$Request: Get_all_Request,
  $$Response: Get_all_Response
};
var service$2 = Service$SolvuuApi0.Create.service(entity);

function path$2(param) {
  return Curry._1(Service$SolvuuApi0.Create.$$Request.path, entity);
}

var body$2 = Curry._1(Service$SolvuuApi0.Create.$$Request.body, Job_create_request_atd$SolvuuApi0.json_of_info);

var info$2 = Curry._1(Service$SolvuuApi0.Create.$$Request.info, Job_create_request_atd$SolvuuApi0.info_of_json);

var $$Request$1 = {
  Json: Job_create_request_atd$SolvuuApi0.Json,
  json_of_info: Job_create_request_atd$SolvuuApi0.json_of_info,
  info_of_json: Job_create_request_atd$SolvuuApi0.info_of_json,
  path: path$2,
  body: body$2,
  info: info$2
};
var Create = {
  entity: entity,
  service: service$2,
  $$Request: $$Request$1,
  $$Response:
  /* alias */
  0
};
var service$3 = Service$SolvuuApi0.Get_events.service(entity);

var path$3 = Curry._1(Service$SolvuuApi0.Get_events.$$Request.path, entity);

function body$3(param) {
  return Service$SolvuuApi0.Get_events.$$Request.body;
}

var info$3 = Curry._1(Service$SolvuuApi0.Get_events.$$Request.info, entity);

var $$Request$2 = {
  Json: Job_get_events_request_atd$SolvuuApi0.Json,
  json_of_info: Job_get_events_request_atd$SolvuuApi0.json_of_info,
  info_of_json: Job_get_events_request_atd$SolvuuApi0.info_of_json,
  path: path$3,
  body: body$3,
  info: info$3
};
var Get_events = {
  entity: entity,
  service: service$3,
  $$Request: $$Request$2,
  $$Response:
  /* alias */
  0
};
var Json = Job_atd$SolvuuApi0.Json;
var json_of_job_id = Job_atd$SolvuuApi0.json_of_job_id;
var json_of_blob_id = Job_atd$SolvuuApi0.json_of_blob_id;
var json_of_spec = Job_atd$SolvuuApi0.json_of_spec;
var json_of_status = Job_atd$SolvuuApi0.json_of_status;
var json_of_backend = Job_atd$SolvuuApi0.json_of_backend;
var json_of_output = Job_atd$SolvuuApi0.json_of_output;
var json_of_t = Job_atd$SolvuuApi0.json_of_t;
var job_id_of_json = Job_atd$SolvuuApi0.job_id_of_json;
var blob_id_of_json = Job_atd$SolvuuApi0.blob_id_of_json;
var spec_of_json = Job_atd$SolvuuApi0.spec_of_json;
var status_of_json = Job_atd$SolvuuApi0.status_of_json;
var backend_of_json = Job_atd$SolvuuApi0.backend_of_json;
var output_of_json = Job_atd$SolvuuApi0.output_of_json;
var t_of_json = Job_atd$SolvuuApi0.t_of_json;
var $$Event =
/* alias */
0;
var Events =
/* alias */
0;
export { Json, json_of_job_id, json_of_blob_id, json_of_spec, json_of_status, json_of_backend, json_of_output, json_of_t, job_id_of_json, blob_id_of_json, spec_of_json, status_of_json, backend_of_json, output_of_json, t_of_json, Solvuu, $$Event, Events, id, spec, status, backend, output, is_complete, entity, Get_by_id, Get_all, Create, Get_events };
/* service Not a pure module */